/**
 * AppContextDef.js
 *
 * Defines the shape and default values for the HomeIQ app context.
 *
 * Used by: AppContext.jsx, useApp.js, all consumers of the app context
 */

import { createContext } from 'react'

export const AppContext = createContext({
  user: null,
  reports: [],
  loading: true,
  authError: null,
  setUser: () => {},
  setReports: () => {},
  setLoading: () => {},
  setAuthError: () => {},
})
